import * as React from 'react';
export const easybankSvg = React.forwardRef(function easybankSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#86B62C',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M23.93 21.82h2.25c-.7 1.44-1.79 2.15-3.24 2.97a12.35 12.35 0 0 1-6.11 1.4c-2.31 0-4.32-.4-6-1.19a7.93 7.93 0 0 1-3.79-3.49 11.37 11.37 0 0 1 .17-10.56 9.25 9.25 0 0 1 3.86-3.85 11.77 11.77 0 0 1 5.57-1.28c1.77 0 3.35.35 4.73 1.03a7.33 7.33 0 0 1 3.15 2.95 8.28 8.28 0 0 1-.55 9.07c-1.4 1.83-3.17 2.95-5.35 2.95-.58 0-1.02-.3-1.31-.51-.3-.2-.51-.51-.6-.9-.83.81-1.79 1.4-2.88 1.4a4.08 4.08 0 0 1-2.9-1.4 4.5 4.5 0 0 1-1.17-3.23 7.9 7.9 0 0 1 1.41-4.54 5 5 0 0 1 4.34-2.46c1.25 0 2.18.44 2.77 1.4l.27-1.4h2.79L19.74 18c-.09.48-.15.8-.15.93 0 .18.05.32.12.41.09.09.19.13.29.13.35 0 .79-.2 1.3-.62a6.3 6.3 0 0 0 2.4-4.96 5.7 5.7 0 0 0-1.85-4.37 7.4 7.4 0 0 0-5.25-1.74c-1.9 0-3.52.39-4.85 1.16a7.42 7.42 0 0 0-3.02 3.3c-.67 1.38-1 2.9-1 4.42 0 1.49.37 2.84 1.11 4.08A6.55 6.55 0 0 0 12 23.39c1.37.57 2.9.84 4.65.84 1.7 0 3.13-.23 4.34-.7 1.22-.48 2.18-.77 2.92-1.71h.02zm-11.4-4.76c0 .9.17 1.56.53 1.98.37.44.82.64 1.35.64.4 0 .78-.1 1.12-.3.28-.14.54-.35.8-.66.38-.44.7-1.06.96-1.9.28-.82.41-1.6.41-2.3 0-.79-.17-1.41-.55-1.84a1.72 1.72 0 0 0-1.4-.64c-.6 0-1.16.24-1.67.7-.52.48-.9 1.15-1.16 2-.27.88-.4 1.65-.4 2.34v-.02z',
      }),
    ),
  );
});
easybankSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var easybank = {
  category: 'brand',
  colorable: false,
  name: 'easybank',
  svg: easybankSvg,
};
